// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section[data-v-5f86fbf6]:first-of-type{padding-top:84px}@media(min-width: 960px){.section[data-v-5f86fbf6]:first-of-type{padding-top:120px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
